/* eslint-disable react/no-array-index-key */
import React, {useState} from 'react';
import Avatar from 'react-avatar';
import _ from 'lodash';

import {cx} from '../util';

const getInitial = (name) => {
  if (name && name.length > 0) return name[0];
  const code = Math.random() * (92 - 65) + 65;
  return String.fromCharCode(code);
};

const getBackground = () => {
  const colors = ['#dc2626', '#db2777', '#1d4fd8', '#22c55e'];
  const idx = Math.floor(Math.random() * colors.length);
  return colors[idx];
};

/** Helper to fetch smaller Google profile images */
const getImageUrl = (url) => {
  const isGoogleImageWithoutSize = url?.includes('googleusercontent') && !url.includes('=s');
  return isGoogleImageWithoutSize ? `${url}=s100` : url;
};

const Face = ({
  face, borderColor, small, className,
}) => {
  const [name, setName] = useState(getInitial(face.first_name));
  const [color, setColor] = useState(getBackground());
  const width = small ? 24 : 36;

  return (
    <div
      className={className}
      style={{minWidth: width, maxWidth: width, borderColor}}
    >
      <Avatar
        name={name}
        src={getImageUrl(face.profile_img)}
        color={color}
        size={`${width}px`}
        textSizeRatio={2.5}
        className="text-white object-cover"
      />
    </div>
  );
};

const FacePile = ({
  faces, borderColor = 'white', small = false, className, hideOverflow = false,
}) => {
  const width = small ? 24 : 36; // Needed so that leftOver circle can grow
  const count = faces.length;
  const leftOver = count > 3 ? count - 3 : 0;
  const showOverflow = !hideOverflow && leftOver > 0;
  const facesOrdered = _.orderBy(faces, (c) => !!c.profile_img, 'desc')
    .slice(0, Math.min(3, count));

  const overlapClass = small ? '-mr-2' : '-mr-3';
  const baseClasses = (overlap) => `
    rounded-full
    flex
    shrink-0
    justify-center
    items-center
    font-normal
    overflow-hidden
    bg-gray-200
    ${small ? 'h-6 border-2 text-xs' : 'h-9 border-3 text-sm'}
    ${overlap ? overlapClass : ''}
  `;

  return (
    <div className={cx('flex', className)}>
      {facesOrdered.map((face, i) => (
        <Face
          key={i}
          face={face}
          borderColor={borderColor}
          small={small}
          className={baseClasses(i < facesOrdered.length - 1 || showOverflow)}
        />
      ))}
      {showOverflow && (
        <div
          style={{minWidth: `${width}px`, borderColor}}
          className={`text-gray-600 pl-1 pr-1.5 ${baseClasses(false)}`}
        >
          {`+${leftOver}`}
        </div>
      )}
    </div>
  );
};

export default FacePile;
